import { colors } from '@constants/colors';

export const useStyles = () => {
  return {
    button: (isGlowing: boolean) => ({
      '&.Mui-disabled img': {
        filter: 'grayscale(100%)',
        opacity: 0.5,
      },
      '& img': {
        borderRadius: '50%',
        ...(isGlowing
          ? { boxShadow: `0 0 8.71px 6.22px ${colors.white_50}` }
          : {}),
      },
    }),
  };
};
